export default __webpack_public_path__ + "static/media/delete.a1e44bcd.svg";